import { StatusDefinitions } from "../auth/data";

const StatusCol = ({ status = "", type = "", isdot=true }) => {
  return (
    <td>
      <div className="d-flex align-items-center gap-3">
      {isdot &&  <span class={`${StatusDefinitions?.[type][status]?.dot}`}></span>}
        <span class={`${StatusDefinitions?.[type][status]?.color} ${isdot ? "" : "ct_fw_600"}`}>
          {StatusDefinitions?.[type][status]?.value || "-"}
        </span>
      </div>
    </td>
  );
};

export default StatusCol;
